import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import { Box } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import PostcodeSearch from './../../../containers/common/PostcodeSearch/PostcodeSearchContainer';
import AddressForm from './AddressForm';
import { refSetter } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('treatments');

const styles = {
  radioButton: { marginBottom: '5px' },
  radioButtonGroup: { flexDirection: 'column', width: '250px', marginLeft: 0 },
};
export const selectionTypes = {
  patientAddress: 'Patient Address',
  alternativeAddress: 'Alternative Address',
};

class AddressDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showWillAffectVisitsWarning: false,
      selectionType: this.props.treatmentAddress ? selectionTypes.alternativeAddress : selectionTypes.patientAddress,
    };
  }

  setRef = refSetter.bind(this);

  handleChange = () => {
    this.setState({
      showWillAffectVisitsWarning: this.props.hasBundledOrFutureAssignedInstances,
    });
  };

  handleSelectionTypeSwitch = event => {
    this.setState({ selectionType: event.target.value });
    this.handleAlternativeAddress(event.target.value);
  };

  handleAlternativeAddress = alternativeAddressInput => {
    this.props.hasAlternativeAddres(alternativeAddressInput === selectionTypes.alternativeAddress);
  };

  updateAddressFromPostcode = selection => {
    this.alternativeAddressForm.setValue({
      addressLine1: selection.lines[0],
      addressLine2: selection.lines[1],
      addressLine3: selection.lines[2],
      townCity: selection.postTown,
      postCode: selection.value,
    });
  };

  render() {
    const { showWillAffectVisitsWarning, selectionType } = this.state;
    const { innerRef, setValidity, readOnly, patientAddress, treatmentAddress, isImportedFromSystmOne } = this.props;

    let defaultAddressFormValue = {
      addressLine1: undefined,
      addressLine2: undefined,
      addressLine3: undefined,
      townCity: undefined,
      postCode: undefined,
      accessDetails: undefined,
    };

    let alternativeAddressFormValue = {
      addressLine1: undefined,
      addressLine2: undefined,
      addressLine3: undefined,
      townCity: undefined,
      postCode: undefined,
      accessDetails: undefined,
      description: undefined,
    };

    if (patientAddress) {
      defaultAddressFormValue = patientAddress;
    }
    if (treatmentAddress) {
      alternativeAddressFormValue = treatmentAddress;
    }

    return (
      <div>
        <Formsy.Form
          ref={innerRef}
          onChange={this.handleChange}
          onValid={setValidity(true)}
          onInvalid={setValidity(false)}
        >
          <Radio
            value={selectionTypes.patientAddress}
            name="address-radio-button"
            disabled={readOnly || isImportedFromSystmOne}
            style={styles.radioButton}
            color="default"
            onChange={this.handleSelectionTypeSwitch}
            checked={selectionType === selectionTypes.patientAddress}
          />
          <span>Patient Address</span>
          <AddressForm
            ref={this.setRef('patientAddressForm')}
            value={defaultAddressFormValue}
            disabled
            name="patientAddress"
          />
          {!readOnly && (
            <div className="row" style={{ marginTop: 24 }}>
              <Radio
                value={selectionTypes.alternativeAddress}
                name="address-radio-button"
                disabled={readOnly || isImportedFromSystmOne}
                style={styles.radioButton}
                color="default"
                onChange={this.handleSelectionTypeSwitch}
                checked={selectionType === selectionTypes.alternativeAddress}
              />
              <span>Alternative Address</span>
            </div>
          )}
          {!readOnly && (
            <div className="row">
              <PostcodeSearch
                disabled={readOnly || selectionType !== selectionTypes.alternativeAddress}
                onSelect={this.updateAddressFromPostcode}
              />
            </div>
          )}
          <AddressForm
            ref={this.setRef('alternativeAddressForm')}
            value={alternativeAddressFormValue}
            disabled={readOnly || selectionType !== selectionTypes.alternativeAddress || isImportedFromSystmOne}
            name="alternativeAddress"
          />
        </Formsy.Form>
        <Box p={1} flexGrow={1}>
          {showWillAffectVisitsWarning && (
            <div className="row" style={{ marginLeft: '8px', color: '#e84c3d' }}>
              <p>
                * {locale.getMsg('willAffectAssignedVisits')} {locale.getMsg('savingWillUnassign')}
              </p>
            </div>
          )}
        </Box>
      </div>
    );
  }
}

AddressDetails.defaultProps = {
  onFieldsUpdate: () => {},
  innerRef: () => {},
  setValidity: () => {},
  addressDetails: undefined,
  readOnly: false,
  patientAddress: undefined,
  treatmentAddress: undefined,
  hasBundledOrFutureAssignedInstances: false,
};

AddressDetails.propTypes = {
  innerRef: PropTypes.func,
  setValidity: PropTypes.func,
  readOnly: PropTypes.bool,
  patientAddress: PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    addressLine3: PropTypes.string,
    townCity: PropTypes.string,
    postCode: PropTypes.string,
    accessDetails: PropTypes.string,
  }),
  treatmentAddress: PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    addressLine3: PropTypes.string,
    townCity: PropTypes.string,
    postCode: PropTypes.string,
    accessDetails: PropTypes.string,
    description: PropTypes.string,
  }),
  hasBundledOrFutureAssignedInstances: PropTypes.bool,
};

export default AddressDetails;
